import { render, staticRenderFns } from "./SensorExstat.vue?vue&type=template&id=6fb4e4bd&"
import script from "./SensorExstat.vue?vue&type=script&lang=js&"
export * from "./SensorExstat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports